import React from "react";

import { Label } from "shared/components";
import { MutedText } from "shared/styles";
import { IFieldLink } from "shared/types";
import { VisuallyHiddenElement } from "shared/styles/constants";

import { FieldLink, StyledLabel } from "./styles";
import { Required } from "./Required";

export interface FieldLabelProps {
  name: string;
  label: string | JSX.Element;
  hideLabel?: boolean;
  required?: boolean;
  fieldLink?: IFieldLink;
}

export const FieldLabel: React.FC<FieldLabelProps> = ({
  name,
  label,
  hideLabel,
  required,
  fieldLink,
}) => (
  <React.Fragment>
    {hideLabel ? (
      <VisuallyHiddenElement as="label" htmlFor={name}>
        {label}
      </VisuallyHiddenElement>
    ) : (
      <StyledLabel htmlFor={name}>
        <MutedText>
          <Label>{label}</Label>
        </MutedText>
        {required && <Required />}
        {fieldLink && !fieldLink?.hideLabel && (
          <FieldLink
            {...fieldLink}
            onClick={fieldLink.onClick}
            type="button"
            data-testid="field_link"
          >
            {fieldLink.label}
          </FieldLink>
        )}
      </StyledLabel>
    )}
  </React.Fragment>
);
